export function getVideoThumbnail(url, opts = {}) {
  const { seekTo = 0.1, width = 1280 } = opts;

  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    video.crossOrigin = "anonymous";
    video.preload = "metadata";
    video.muted = true;
    video.playsInline = true;

    const clean = () => {
      video.pause();
      video.removeAttribute("src");
      video.load();
    };

    video.onloadedmetadata = () => {
      const t = Math.min(Math.max(seekTo, 0), Math.max(0, (video.duration || 0) - 0.05));
      video.currentTime = Number.isFinite(t) ? t : 0;
    };

    video.onseeked = () => {
      try {
        const canvas = document.createElement("canvas");
        const ratio = video.videoWidth / video.videoHeight || (16 / 9);
        canvas.width = width;
        canvas.height = Math.round(width / ratio);

        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        const dataUrl = canvas.toDataURL("image/jpeg", 0.85);
        clean();
        resolve(dataUrl);
      } catch (e) {
        clean();
        reject(e);
      }
    };

    video.onerror = (e) => {
      clean();
      reject(e);
    };

    video.src = url;
  });
}